import { generateTimeOptionsWithSeconds } from "../../../../utils/functions";
import { CONTACTMETHOD, LOANFOREIGNNATIONALLOAN, NHCTIME, OSLLOANGRADE } from "../../../../components/core/homesites/homesiteColumnConsts";

const METHODOFCONTACTOPTIONS = [
  { value: "", label: "Remove Method of Contact" },
  { value: "Phone", label: "Phone" },
  { value: "Email", label: "Email" },
  { value: "Text", label: "Text" },
];

const OSLLONEGRADEOPTIONS = [
  { value: "", label: "None" },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
];

const FOREIGNNATIONALLOANOPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const TIMEOPTIONSWITHSECONDS = generateTimeOptionsWithSeconds().map((time) => ({
  value: time,
  label: time,
}));

export class BuyerListingOptionsProvider {
  
  static getOptionsByField(field: string) {
    switch (field) {
      case CONTACTMETHOD:
        return METHODOFCONTACTOPTIONS;
      case OSLLOANGRADE:
        return OSLLONEGRADEOPTIONS;
      case LOANFOREIGNNATIONALLOAN:
        return FOREIGNNATIONALLOANOPTIONS;
      case NHCTIME:
        return TIMEOPTIONSWITHSECONDS;
    }
    return [];
  }
}
